import { FormItemProps } from '../templates/FormProps';
import useRoleMemo from '@vindr/utils/hooks/useRoleMemo';
import { Form, TimePicker } from 'antd';

const FormTimePicker = <T,>({
  name,
  label,
  placeholder,
  rules,
  required,
  disabled,
  className,
  noStyle,
  ...props
}: FormItemProps<T>) => {
  const rulesMemo = useRoleMemo({ required, rules, disabled });

  return (
    <Form.Item
      {...{ name, label, placeholder }}
      className={className}
      noStyle={noStyle}
      rules={rulesMemo}
    >
      <TimePicker
        className="w-full"
        disabled={disabled}
        placeholder={placeholder}
        {...props}
        getPopupContainer={(trigger) => trigger.parentElement}
      />
    </Form.Item>
  );
};

export default FormTimePicker;
